import { apiClient } from "@/lib/apiClient";
import type {
  CompanyTrainingProfileApiItem,
  CompanyTrainingProfileCreateDto,
  CompanyTrainingProfileDetailResponseApi,
  CompanyTrainingProfileListParams,
  CompanyTrainingProfileListResponseApi,
  CompanyTrainingProfileUpdateDto,
} from "../types/company-training-profiles.types";

const ENDPOINT = "/api/admin/company-training-profiles";

export const companyTrainingProfilesApi = {
  getAll: async (
    params?: CompanyTrainingProfileListParams,
  ): Promise<{ data: CompanyTrainingProfileApiItem[]; total: number }> => {
    const query: Record<string, unknown> = {};
    if (params?.page != null) query.page = params.page;
    if (params?.limit != null) query.limit = params.limit;
    if (params?.search) query.search = params.search;
    if (params?.sortBy) query.sortBy = params.sortBy;
    if (params?.sortOrder) query.sortOrder = params.sortOrder;

    const { data } = await apiClient.get<CompanyTrainingProfileListResponseApi>(
      ENDPOINT,
      { params: query },
    );

    const list = Array.isArray(data?.data) ? data.data : [];
    return { data: list, total: data?.count ?? list.length };
  },

  getById: async (
    id: string,
  ): Promise<CompanyTrainingProfileApiItem> => {
    const { data } =
      await apiClient.get<CompanyTrainingProfileDetailResponseApi>(
        `${ENDPOINT}/${id}`,
      );
    if (!data?.data) throw new Error("Company training profile not found");
    return data.data;
  },

  create: async (
    body: CompanyTrainingProfileCreateDto,
  ): Promise<CompanyTrainingProfileApiItem> => {
    const { data } =
      await apiClient.post<CompanyTrainingProfileDetailResponseApi>(
        ENDPOINT,
        body,
      );
    if (!data?.data) throw new Error("Create failed");
    return data.data;
  },

  update: async (
    id: string,
    body: CompanyTrainingProfileUpdateDto,
  ): Promise<CompanyTrainingProfileApiItem> => {
    const { data } =
      await apiClient.patch<CompanyTrainingProfileDetailResponseApi>(
        `${ENDPOINT}/${id}`,
        body,
      );
    if (!data?.data) throw new Error("Update failed");
    return data.data;
  },

  remove: async (id: string): Promise<void> => {
    await apiClient.delete(`${ENDPOINT}/${id}`);
  },
};
